import type { ReactElement, ReactNode } from 'react';
import styles from './Tabs.module.scss';

export interface TabItem<K extends string> {
  key: K;
  label: ReactNode;
}

/** Вкладки внутри страницы (role=tablist). Не помещаются — прокручиваются сами. */
export function Tabs<K extends string>({ items, active, onChange, label }: { items: readonly TabItem<K>[]; active: K; onChange(key: K): void; label: string }): ReactElement {
  return (
    <div className={styles.tabs} role="tablist" aria-label={label}>
      {items.map((item) => (
        <button key={item.key} type="button" role="tab" aria-selected={item.key === active} className={styles.tab} onClick={() => onChange(item.key)}>
          {item.label}
        </button>
      ))}
    </div>
  );
}

export interface NavTabItem {
  href: string;
  label: ReactNode;
  current: boolean;
  onNavigate(): void;
}

/** Навигационные вкладки — ссылки (разделы настроек блога). */
export function NavTabs({ items, label }: { items: readonly NavTabItem[]; label: string }): ReactElement {
  return (
    <nav className={styles.tabs} aria-label={label}>
      {items.map((item) => (
        <a
          key={item.href}
          href={item.href}
          className={styles.tab}
          aria-current={item.current ? 'page' : undefined}
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
            event.preventDefault();
            item.onNavigate();
          }}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
}
